var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.5809,
    height: 54.2941,
    viewBox: "0 0 49.5809 54.2941",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2,.cls-3{fill:#d0cfce;}.cls-3{stroke:#d0cfce;}.cls-3,.cls-4{stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.cls-4{fill:none;stroke:#000;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "emoji"
  }, /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "40.9345 13.7366 45.521 10.187 48.5809 14.1407 44.3279 17.4322"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 18.4912,
    y: 1,
    width: 11.0083,
    height: 6.2941
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 24,
    cy: 30.2941,
    r: 23
  })), /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 24,
    cy: 30.2941,
    r: 23
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "43.5446 11.7166 45.521 10.187 48.5809 14.1407 46.7482 15.5591"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "19.5 3.7271 19.5 1 28.5 1 28.5 3.8931"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5261,
    cy: 10.9817,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5261,
    cy: 49.0239,
    r: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.9756,
    cy: 16.55297,
    rx: 0.98779,
    ry: 1.01209,
    transform: "translate(-.87482 30.99395) rotate(-45)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.0756,
    cy: 43.45265,
    rx: 0.98779,
    ry: 1.01209,
    transform: "translate(-27.77459 19.85151) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5472,
    cy: 30.0028,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.505,
    cy: 30.0028,
    r: 1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 24.0185,
    y1: 29.91,
    x2: 8.6185,
    y2: 29.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 24.0632,
    y1: 29.9253,
    x2: 13.1738,
    y2: 40.8147
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.97539,
    cy: 43.45276,
    rx: 1.01209,
    ry: 0.98779,
    transform: "translate(-19.8959 38.87256) rotate(-45)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.07581,
    cy: 16.55276,
    rx: 1.01209,
    ry: 0.98779,
    transform: "translate(-8.75344 11.97286) rotate(-45)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.65ebb8fa8e91941c2f269beca4e02913.svg";
export { ForwardRef as ReactComponent };